// Servicio del asistente "Solicitar un módulo o función nueva".
// Mismo patron que solicitudesCambioService.js: axios + token de localStorage.
import axios from "axios";
import { PATH } from "../../redux/utils";

const api = axios.create({ baseURL: PATH });

const authHeader = () => {
  const token = localStorage.getItem("tokenadmin") || localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const wizardService = {
  async crearBorrador() {
    const { data } = await api.post("/solicitudes-wizard", {}, { headers: authHeader() });
    return data;
  },

  async obtenerBorrador(idWizard) {
    const { data } = await api.get(`/solicitudes-wizard/${idWizard}`, { headers: authHeader() });
    return data;
  },

  async listarMisBorradores() {
    const { data } = await api.get("/solicitudes-wizard/mias", { headers: authHeader() });
    return data;
  },

  async guardarPaso(idWizard, paso, respuesta) {
    const { data } = await api.put(
      `/solicitudes-wizard/${idWizard}/paso`,
      { paso, respuesta },
      { headers: authHeader() }
    );
    return data;
  },

  async previsualizarResumen(idWizard) {
    const { data } = await api.get(`/solicitudes-wizard/${idWizard}/resumen`, { headers: authHeader() });
    return data.resumen_cliente;
  },

  async subirArchivo(idWizard, file) {
    const fd = new FormData();
    fd.append("archivo", file, file.name);
    const { data } = await api.post(`/solicitudes-wizard/${idWizard}/archivos`, fd, { headers: authHeader() });
    return data;
  },

  async eliminarArchivo(idWizard, idArchivo) {
    await api.delete(`/solicitudes-wizard/${idWizard}/archivos/${idArchivo}`, { headers: authHeader() });
  },

  async enviar(idWizard) {
    const { data } = await api.post(`/solicitudes-wizard/${idWizard}/enviar`, {}, { headers: authHeader() });
    return data;
  },

  async obtenerCatalogo() {
    const { data } = await api.get("/solicitudes-wizard/opciones/catalogo", { headers: authHeader() });
    return data;
  },

  async obtenerFichaTecnica(idWizard) {
    const { data } = await api.get(`/solicitudes-wizard/${idWizard}/ficha-tecnica`, { headers: authHeader() });
    return data;
  },

  // Modulo "Programador": ficha técnica a partir del id de la solicitud de cambio.
  async obtenerFichaTecnicaPorSolicitud(idSolicitud) {
    const { data } = await api.get(`/solicitudes-wizard/por-solicitud/${idSolicitud}/ficha-tecnica`, { headers: authHeader() });
    return data;
  },

  authHeader,
};
